import {TouchableOpacity, Image, StyleSheet, Platform} from 'react-native';
import React from 'react';
import {isWeb} from '../../utils/utils';
const userAgent = isWeb ? window.navigator.userAgent : null;
import {isSafari, isTablet, isChrome} from 'react-device-detect';
const isPadChromeBrowser = userAgent?.includes('iPad') && isChrome;
const iPhoneChromeBrowser = userAgent?.includes('iPhone OS') && isChrome;
const androidChromeBrowser = userAgent?.includes('Android') && isChrome;

const PasswordHint = props => {
   //alert(userAgent);
   return (
      <TouchableOpacity
         onPress={props?.onPress}
         style={[
            styles.container,
            {
               bottom:
                  (isSafari && !props?.isLandscapeMode) ||
                  (isSafari && isTablet) ||
                  isPadChromeBrowser ||
                  iPhoneChromeBrowser ||
                  androidChromeBrowser
                     ? 28
                     : 25,
               cursor: 'pointer',
               ...Platform.select({
                  windows: {
                     bottom: 28,
                  },
                  ios: {
                     bottom: 25,
                  },
                  android: {
                     bottom: 30,
                  },
               }),
            },
         ]}>
         <Image
            source={
               props?.showPassword
                  ? require('../../assets/eye-open.png')
                  : require('../../assets/eye-close.png')
            }
            style={{
               width: 18,
               height: 18,
               //tintColor: '#5e718d',
            }}
         />
      </TouchableOpacity>
   );
};
const styles = StyleSheet.create({
   container: {
      position: 'absolute',
      width: 18,
      height: 18,
      alignSelf: 'flex-end',
      right: 10,
   },
});
export default PasswordHint;
